<!--measurement 抄表计量-->
<template>
  <div class="myusePowerDifference">
    <div class="con">
      <!-- 左边树形 -->
      <div class="tree-left">
        <elUnitTree @checkFun='checkFun' :dataList='virtualDeviceList'></elUnitTree>
      </div>
      <div class="right-table">
        <!-- 搜索 -->
        <div class="Files-top">
          <div class="ic-left">
            <span>抄表计量</span>
          </div>
          <div class="btns">
            <el-button @click="exportExcel" type="primary" class="last-el-button">导出</el-button>
          </div>
        </div>
        <div class="search-input-btn" style="width:100%">
          <div class="input-small mr-20 myinput">
            <span></span>
            <el-select v-model="targetApptype" placeholder="请选择" @change="select_fn">
              <el-option v-for="item in targetApptypeGroups" :key="item.no" :label="item.name"
                :value="item.no"></el-option>
            </el-select>
          </div>
          <div class="input-small mr-20 myinput">
            <span></span>
            <el-select v-model="nowTimetype" placeholder="请选择">
              <el-option v-for="item in timestype" :key="item.en" :label="item.ch" :value="item.en"></el-option>
            </el-select>
          </div>
          <div class="input-small">
            <span></span>
            <el-date-picker v-model="timerValue" type="date" placeholder="选择时间" align="right"
              :picker-options="pickerOptions"> </el-date-picker>
          </div>
          <el-button type="primary" plain @click="search" class="search-btn">查询</el-button>
        </div>
        <!-- echart图 -->
        <div class="mychart" style="width:100%;height:calc(100% - 285px)">
          <vchart style="height: 100%;" ref='vchart'></vchart>
        </div>
        <el-table :data="tableData" border v-loading="loading" stripe style="width: 100%" height="185px">
          <el-table-column label="序号" width="90" align="center">
            <template slot="empty">
              <span class="noData">
                <img src="@/assets/noData.png" alt="暂无数据">
                <span class="text">暂无数据</span>
              </span>
            </template>
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="capacityName" label="变量名" width="180"> </el-table-column>
          <el-table-column v-for="(item,index) in columnList" :key='index' :prop="item.key" :label="item.label"
            align="center" width="90"> </el-table-column>
        </el-table>

      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
  import elUnitTree from '@/components/module/newTree/elUnitTree.vue'
  import vchart from '@/components/module/chart/vchart.vue'
  export default {

    components: {
      elUnitTree,
      vchart
    },
    props: [],
    data () {
      return {
        loading: false,
        heights: document.getElementById('app').clientHeight-720,
        timerValue: new Date(),
        pickerOptions: {
          disabledDate (time) {
            return time.getTime()>Date.now();
          },

          shortcuts: [{
            text: '今天',
            onClick (picker) {
              picker.$emit('pick',new Date());
            }
          },{
            text: '昨天',
            onClick (picker) {
              const date=new Date();
              date.setTime(date.getTime()-3600*1000*24);
              picker.$emit('pick',date);
            }
          },{
            text: '一周前',
            onClick (picker) {
              const date=new Date();
              date.setTime(date.getTime()-3600*1000*24*7);
              picker.$emit('pick',date);
            }
          }]
        },
        timestype: [{
          ch: '日',
          en: 'day'
        },
        {
          ch: '周',
          en: 'week'
        },
        {
          ch: '月',
          en: 'month'
        },
        {
          ch: '季',
          en: 'quarter'
        },
        {
          ch: '年',
          en: 'year'
        }
        ],
        targetApptypeGroups: [
          {
            name: "电",
            no: 36
          },
          {
            name: "水",
            no: 237
          },
          {
            name: "气",
            no: 361
          },
        ],
        columnList: [],
        nowVirtualDevice: undefined,
        nowTimetype: 'day',
        options: {},
        dataObject: {},
        nowIndex: 0,
        pageLen: 5,
        weekList: ['星期一','星期二','星期三','星期四','星期五','星期六','星期日'],
        from2name: {},
        targetApptype: 36,
        endTime: '',
        endCanSelect: new Date(new Date().getTime()+60*60*24),
        radio: 36,
        unit: '',
        variableTree: [],
        tableData: []
      }
    },
    created () {},
    mounted () {
      for(let i=0;i<24;i++) {
        this.columnList.push({
          label: i+'时',
          key: i+'时',
        })
      }
      debugPage=this
      //初始化图表
      this.options=this.$refs.vchart.getDefaultOptions()
      this.options.toolbox={
        show: true,
        showTitle: true, // 隐藏默认文字，否则两者位置会重叠
        top: '-5',
        right: "30",
        feature: {
          magicType: {
            type: ['line','bar','stack','tiled'],title: {
              line: '切换为折线图',
              bar: '切换为柱状图',
              stack: '切换为堆叠',
              tiled: '切换为平铺',
            }
          },

          saveAsImage: {
            show: true,
            title: '下载图片'
          },
          // dataView: { show: true, readOnly: true, lang: ['', '关闭'] },
        },

      },
        this.options.backgroundColor='#FFFFFF'
      this.options.tooltip.formatter=(params,ticket,callback) => {
        if(params[0].data==undefined) {
          return ""
        }
        var h=params[0].data[0]
        var label=h+"</br>"
        params.forEach(item => {
          var values;
          if(isnull(item.data[1])) {
            values="无采集数据";
          } else {
            values=cutDigital(item.data[1]);
          }
          label+=item.seriesName+" : "+values+" (kW·h)</br>"
        })
        return label;
      }
      this.options.yAxis={
        splitLine: {
          show: true
        }
      }
      switch(this.targetApptype) {
        case 36:
          this.options.title.text="用电量(KW·h)"
          break
        case 237:
          this.options.title.text="用水量(t)"
          break
        case 361:
          this.options.title.text="用气量(m³)"
          break
        case 362:
          this.options.title.text="用汽量"
          break
      }
      this.$refs.vchart.setData(this.options,true)

    },
    destroyed () {},
    computed: {
      nowTimeInterval () {
        return this.cacheStore.getters.getNowTimeInterval
      },
      nowUnit () {
        return this.$store.unitStore.getters.getNowUnit
      },
      getResourcesByName () {
        return this.$store.resourcesStore.getters.getResourcesByName
      },
      cacheStore () {
        return this.$store.cacheStore
      },
      virtualDeviceList () {
        if(isempty(this.nowUnit)) {
          return []
        }
        return [deviceList(this.$store.deviceStore.getters.getReadDeviceTreeWithTypeNos(this.targetApptype,this.nowUnit.id))]
      },
      datePickerType () {
        switch(this.nowTimetype) {
          case 'day':
          case 'week':
            return 'day'
          case 'month':
          case 'quarter':
            return 'month'
          case 'year':
            return 'year'
          case 'custom':
            return 'custom'
        }
      },
      apptypeGroups () {
        //所有已选中的设备所具有的变量类型组
        var list=[]
        var apptypeGroupIds=[]
        this.variableTree.forEach(apptypeGroup => {
          if(!apptypeGroupIds.includes(apptypeGroup.id)) {
            apptypeGroupIds.push(apptypeGroup.id)
            list.push(apptypeGroup)
          }
        })
        //排序
        return list.sort((a,b) => {
          return a.serialnum-b.serialnum
        })
      },
      nowSelectDate () {
        return this.cacheStore.getters.getNowSelectDate
      },

      columns () {
        var list=[{
          name: '变量名',
          weight: 3,
        }]
        switch(this.nowTimetype) {
          case 'day':
            //取出每个整点值
            for(var i=0;i<24;i++) {
              var label=(i<10? "0":'')+(i)+":00-"+(i+1<10? "0":'')+(i+1)+":00"
              list.push({
                name: label //i + ' - ' + (i + 1)
              })
            }
            break
          case 'week':
            for(var i=0;i<7;i++) {
              list.push({
                name: this.weekList[i]
              })
            }
            break
          case 'month':
            let lasDay=new Date(this.nowSelectDate.format("yyyy"),this.nowSelectDate.format("MM"),0).getDate()
            for(var i=1;i<=lasDay;i++) {
              list.push({
                name: i+"日"
              })
            }
            break
          case 'quarter':
            for(var i=0;i<3;i++) {
              list.push({
                name: this.getQuarterList(this.nowSelectDate)[i]
              })
            }
            break
          case 'year':
            for(var i=1;i<=12;i++) {
              list.push({
                name: i+"月"
              })
            }
            break
          case 'custom':
            var time=this.nowTimeInterval.endDate.getTime()-this.nowTimeInterval.startDate.getTime()
            var dayNum=Math.floor((time)/(24*60*60*1000))+1
            var value=[]
            if(isNaN(parseFloat(value))||isnull(parseFloat(value))) {
              value=undefined
            }
            if(this.nowTimeInterval.endDate.getMonth()!=this.nowTimeInterval.startDate.getMonth()) {
              var lastmonthNum=dayNum-this.nowTimeInterval.endDate.getDate()
              for(var i=0;i<lastmonthNum;i++) {
                list.push({
                  name: this.nowTimeInterval.startDate.getMonth()+1+'月'+(this.nowTimeInterval.startDate.getDate()+i)+'日'
                })
              }
              for(var j=0;j<this.nowTimeInterval.endDate.getDate();j++) {
                list.push({
                  name: this.nowTimeInterval.endDate.getMonth()+1+'月'+(j+1)+'日'
                })
              }
            } else {
              if(this.nowTimeInterval.startDate.getDate()==this.nowTimeInterval.endDate.getDate()) {
                list.push({
                  name: this.nowTimeInterval.endDate.getMonth()+1+'月'+(this.nowTimeInterval.endDate.getDate())+'日'
                })
              } else {
                for(var i2=0;i2<dayNum;i2++) { //l.length
                  list.push({
                    name: this.nowTimeInterval.startDate.getMonth()+1+'月'+(this.nowTimeInterval.startDate.getDate()+i2)+'日'
                  })
                }
              }

            }
            break
        }
        return list
      },
      nowVariableNames () {
        //当前应该显示的变量
        var variableList=[]
        for(var i=0,len=this.variableTree.length;i<len;i++) {
          this.variableTree[i].next.forEach(v => {
            if(v.typeNo==this.targetApptype) {
              this.unit=this.variableTree[i].unit
              this.from2name[v.fromName]=v.name
              variableList.push(v.fromName)
            }
          })
        }
        return variableList
      },

      nowVariableNamesS () {
        //当前应该显示的变量
        var variableList=[]
        this.nowDevice.forEach(item => {
          this.nowVirtualDevice=item
          for(var i=0,len=this.variableTree.length;i<len;i++) {
            this.variableTree[i].next.forEach(v => {
              if(v.typeNo==this.targetApptype) {
                this.from2name[v.fromName]=v.name
                variableList.push(v.fromName)
              }
            })
          }
        })

        return variableList
      },
      showDataList () {
        //用于渲染的合并后的数组
        if(isempty(this.dataObject)) {
          return []
        }
        //取出数据中的有效数据组织为数组
        var list=[]
        var keys=Object.keys(this.dataObject)
        for(var i=0,len=keys.length;i<len;i++) {
          var key=keys[i]
          var dataList=this.dataObject[key].map(i => {
            if(isNaN(parseFloat((i)))||isnull(parseFloat((i)))) {
              return undefined
            } else {
              return i
            }
          })
          // if(this.nowTimetype == "month") {
          // 	let lasDay = new Date(this.nowSelectDate.format("yyyy"), this.nowSelectDate.format("MM"), 0).getDate()
          // 	if(lasDay == 30) {
          // 		dataList.shift()
          // 	}
          // }
          //var vList = [key.subByFirstChar('.')]
          var vList=[key]
          vList.addAll(dataList)
          list.push(vList)
        }
        return list.sort()
      },
      chartDataList () {
        //图表使用的数据
        var list=[]
        for(var i=0,len=this.showDataList.length;i<len;i++) {
          var l=this.showDataList[i]
          var l2=[this.nowVariableNames[i]] //变量名称
          switch(this.nowTimetype) {
            case 'day':
              //取出每个整点值
              for(var i2=1,len2=25;i2<len2;i2++) { //l.length
                var value=l[i2]
                if(isNaN(parseFloat(value))||isnull(parseFloat(value))) {
                  value=undefined
                }
                var label=(i2-1<10? "0":'')+(i2-1)+":00-"+(i2<10? "0":'')+i2+":00"
                l2.push([label,value])
              }
              break
            case 'week':
              for(var i2=1,len2=8;i2<len2;i2++) { //l.length
                var value=l[i2]
                if(isNaN(parseFloat(value))||isnull(parseFloat(value))) {
                  value=undefined
                }
                l2.push([this.weekList[i2-1],value])
              }
              break
            case 'month':
              let lasDay=new Date(this.nowSelectDate.format("yyyy"),this.nowSelectDate.format("MM"),0).getDate()+1
              //判断月份是否有31
              for(var i2=1,len2=lasDay;i2<len2;i2++) { //l.length
                var value=l[i2]
                if(isNaN(parseFloat(value))||isnull(parseFloat(value))) {
                  value=undefined
                }
                l2.push([(i2)+'日',value])
              }
              break
            case 'quarter':
              for(var i2=1,len2=4;i2<len2;i2++) { //l.length
                var value=l[i2]
                if(isNaN(parseFloat(value))||isnull(parseFloat(value))) {
                  value=undefined
                }
                l2.push([this.getQuarterList(this.nowSelectDate)[i2-1],value])
              }
              break
            case 'year':
              for(var i2=1,len2=13;i2<len2;i2++) { //l.length
                var value=l[i2]
                if(isNaN(parseFloat(value))||isnull(parseFloat(value))) {
                  value=undefined
                }
                l2.push([(i2)+'月',value])
              }
              break
            case 'custom':
              var time=this.nowTimeInterval.endDate.getTime()-this.nowTimeInterval.startDate.getTime()
              var dayNum=Math.floor((time)/(24*60*60*1000))+1
              var value=[]
              if(isNaN(parseFloat(value))||isnull(parseFloat(value))) {
                value=undefined
              }
              if(this.nowTimeInterval.endDate.getMonth()!=this.nowTimeInterval.startDate.getMonth()) {
                var lastmonthNum=dayNum-this.nowTimeInterval.endDate.getDate()
                for(var i=0;i<lastmonthNum;i++) {
                  l2.push([this.nowTimeInterval.startDate.getMonth()+1+'月'+(this.nowTimeInterval.startDate.getDate()+i)+'日',l[i+1]])
                }
                for(var j=0;j<this.nowTimeInterval.endDate.getDate();j++) {
                  l2.push([this.nowTimeInterval.endDate.getMonth()+1+'月'+(j+1)+'日',l[j+lastmonthNum+1]])
                }
              } else {
                if(this.nowTimeInterval.startDate.getDate()==this.nowTimeInterval.endDate.getDate()) {
                  l2.push([this.nowTimeInterval.endDate.getMonth()+1+'月'+(this.nowTimeInterval.endDate.getDate())+'日',l[1]])
                } else {
                  for(var i2=0;i2<dayNum;i2++) { //l.length
                    l2.push([this.nowTimeInterval.startDate.getMonth()+1+'月'+(this.nowTimeInterval.startDate.getDate()+i2)+'日',l[i2+1]])
                  }
                }
              }
              l2.push([this.nowTimeInterval.startDate.formatByTime(),l[1]])
              break
          }
          list.push(l2)
        }
        return list
      },
      nowPage () {
        //按照页码来返回当前应该显示的列表
        return this.showDataList.filter((item,index) => {
          return index>=this.nowIndex*this.pageLen&&index<(this.nowIndex+1)*this.pageLen
        })
      },
      getDateText () {
        return (date,timeInterval) => {
          switch(this.nowTimetype) {
            case 'day':
              return date.formatByDate('-')
            case 'week':
              return date.formatByDate('-')
            case 'month':
              return date.formatByMonth('-')
            case 'quarter':
              return date.formatByMonth('-')
            case 'year':
              return date.getFullYear()+''
            case 'custom':
              return timeInterval.startDate.formatByDate('/')+"—"+timeInterval.endDate.formatByDate('/')
          }
        }
      },
    },
    watch: {
      nowVirtualDevice (nv,ov) {
        this.search();
      },
      nowVariableNames (nv,ov) {
        //this.search()
      },
      chartDataList (nv,ov) {
        //重新渲染
        // console.log(nv);
        this.reloadChart(nv)
      },
      nowTimetype (nv,ov) {
        //this.search()
      },
      nowSelectDate (nv,ov) {
        //this.search()
      },
      nowTimeInterval (nv,ov) {
        //this.search()
      },
      targetApptype (nv,ov) {
        //切换能源类型刷新页面
        this.dataObject={}
        switch(this.targetApptype) {
          case 36:
            this.options.title.text="用电量(KW·h)"
            break
          case 237:
            this.options.title.text="用水量(t)"
            break
          case 361:
            this.options.title.text="用气量(m³)"
            break
          case 362:
            this.options.title.text="用汽量"
            break
        }
        this.$refs.vchart.setData(this.options,true)
      }
    },
    methods: {
      //树形结构选择
      checkFun (val) {
        this.nowVirtualDevice=val
      },
      select_fn () {},

      selectTimeInterval (ev) {
        this.cacheStore.commit('setNowTimeInterval',ev)
        this.$refs.endPicker.hide()
      },
      search () {
        //先查询设备信息  再查数据
        if(isempty(this.nowVirtualDevice)) {
          return;
        }
        var deviceNoList=[]

        for(var i=0;i<this.nowVirtualDevice.length;i++) {
          deviceNoList.push(this.nowVirtualDevice[i].no)

        }
        this.loading=true
        this.$api.variableApi.getVariableTree(deviceNoList.join(","),respon => {
          this.variableTree=respon

          if(isempty(this.nowVariableNames)) {
            return
          }
          this.dataObject={}

          this.$api.historyApi.getHistoryDifferenceRanking(this.nowVariableNames.join(','),this.nowTimetype,this.timerValue
            .getTime(),'',
            respon => {
              this.dataObject=respon
              this.tranList(respon)
            })

        })
      },
      reloadChart (list) {
        var selected={}
        var legend=[]
        var seriesList=[]
        for(var i=0,len=list.length;i<len;i++) {
          let item=list[i]
          var name=list[i].shift()
          seriesList.push({
            name: name,
            type: 'line',
            smooth: true,
            symbol: 'emptyCircle',
            sampling: 'average',
            data: item
          })
          selected[name]=i<12? true:false
          legend.push({
            name: name,
            icon: 'roundRect'
          })
        }
        this.options.series=seriesList
        this.options.legend.data=legend
        this.options.legend.selected=selected
        this.options.tooltip.formatter=(params,ticket,callback) => {
          if(params[0].data==undefined) {
            return ""
          }
          var h=params[0].data[0]
          var label=h+"</br>"
          params.forEach(item => {
            var values;
            if(isnull(item.data[1])) {
              values="无采集数据";
            } else {
              values=cutDigital(item.data[1]);
            }
            label+=item.seriesName+" : "+values+" ("+this.unit+")</br>"
          })
          return label;
        }
        // switch (this.targetApptype) {
        // 	case 36:
        // 		//this.options.title.text = this.nowVirtualDevice.name + "-用电量"
        // 		this.options.title.text = "用电量"
        // 		break
        // 	case 237:
        // 		this.options.title.text = "用水量"
        // 		break
        // 	case 361:
        // 		this.options.title.text = "用气量"
        // 		break
        // 	case 362:
        // 		this.options.title.text = "用汽量"
        // 		break
        // }
        this.$refs.vchart.setData(this.options,true)
      },
      tranList (data) {
        this.tableData=[]
        // columnList
        var index=-1
        for(let k in data) {
          // console.log(k,data[k]);
          this.tableData.push({
            'capacityName': k
          })
          index++
          data[k].forEach((item,i) => {
            this.tableData[index][i+'时']=item
          })
        }
        this.loading=false
      },
      getQuarterList (date) {
        switch(date.getMonth()/3|0) {
          case 0:
            return ['一月','二月','三月']
          case 1:
            return ['四月','五月','六月']
          case 2:
            return ['七月','八月','九月']
          case 3:
            return ['十月','十一月','十二月']
        }
      },
      exportExcel () {
        this.nowDevice=[this.nowVirtualDevice]
        let list=this.$store.deviceStore.getters.getReadDeviceTreeWithTypeNos(this.targetApptype,this.nowUnit.id)
        var title='电能消耗'
        switch(this.nowTimetype) {
          case "custom":
            title=this.nowTimeInterval.startDate.format("yyyy年MM月dd日")+"至"+this.nowTimeInterval.endDate.format("yyyy年MM月dd日")+"电能消耗"
            break;
          case "day":
            title=this.nowSelectDate.format("yyyy年MM月dd日")+"电能消耗"
            break;
          case "week":
            let getDate=getMonthWeek(this.nowSelectDate.format("yyyy"),this.nowSelectDate.format("MM"),this.nowSelectDate.format("dd"));
            title=getDate.getYear+"年"+getDate.getMonth+"月第"+getDate.getWeek+"周"+"电能消耗"
            break;
          case "month":
            title=this.nowSelectDate.format("yyyy年MM月")+"电能消耗"
            break;
          case "quarter":
            title="第"+this.nowSelectDate.format("q")+"季电能消耗"
            break;
          case "year":
            title=this.nowSelectDate.format("yyyy")+"年电能消耗"
            break;
          default:
            title="电能消耗"
        }

        if(this.nowTimetype!='custom') {
          this.$api.reportApi.exportHistoryDifferenceRanking(title,this.nowVariableNamesS.join(','),this.nowSelectDate.getTime(),this.nowTimetype,
            respon => {
              saveAs(DWSystemSetting.downloadUrl+'/'+respon,title+".xls")
            })
        } else {
          //时间段的导出
          this.$api.reportApi.exportHistoryDifferenceRankingCustom(title,this.nowVariableNamesS.join(','),this.nowTimeInterval.startDate.getTime(),this.nowTimeInterval.endDate.getTime(),this.nowTimetype,
            respon => {
              saveAs(DWSystemSetting.downloadUrl+'/'+respon,title+".xls")
            })
        }

      },
      exportAllExcel () {
        this.$dialogMethod.showLoading("正在生成报告。。。")
        if(this.nowTimetype!='custom') {
          this.$api.reportApi.exportAllPowerDifferenceRanking(this.nowSelectDate.getTime(),respon => {
            if(!respon.includes('%2F')) {
              this.$dialogMethod.showMessage(respon)
              return
            }
            saveAs(DWSystemSetting.downloadUrl+'/'+respon,respon.substring(respon.lastIndexOf('%2F')+3))
            this.$dialogMethod.closeLoading()
          })
        } else {
          this.$api.reportApi.exportAllPowerDifferenceRankingCustom(this.nowTimeInterval.startDate.getTime(),this.nowTimeInterval.endDate.getTime(),this.nowTimetype,respon => {
            if(!respon.includes('%2F')) {
              this.$dialogMethod.showMessage(respon)
              return
            }
            saveAs(DWSystemSetting.downloadUrl+'/'+respon,respon.substring(respon.lastIndexOf('%2F')+3))
            this.$dialogMethod.closeLoading()
          })
        }
      }
    }
  }
</script>

<style scoped lang='scss'>
  .myusePowerDifference {
    .con {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      display: flex;

      .tree-left {
        width: 3rem;
        height: 100%;
        padding: 20px 12px 12px 12px;
        box-sizing: border-box;
        background-color: #fff;
        margin-right: 8px;

        .btns {
          display: flex;
          // justify-content: space-evenly;
          margin-bottom: 8px;

          button {
            margin-right: 12px;
          }

          .el-button--mini {
            padding: 7px 10px !important;
          }

          .el-button+.el-button {
            margin-left: 0px;
          }
        }

        .search {
          display: flex;
          justify-content: center;
          margin-bottom: 12px;
        }

      }

      .right-table {
        width: calc(100% - 3.08rem);
        height: 100%;
        padding: 12px 20px 20px 20px;
        box-sizing: border-box;
        background-color: #fff;
      }
    }
  }
</style>